export default __webpack_public_path__ + "static/media/Group11903.63245356.svg";